export default __webpack_public_path__ + "static/media/image-003.61e6a8df.jpg";